import { TrendingUp, FileWarning, AlertTriangle, Radio, Scale, Users, ShieldAlert, Siren, Plus } from "lucide-react";

export function Classifiers() {
  const categories = [
    {
      icon: TrendingUp,
      title: "Insider Trading / MNPI",
      desc: "Monitors communications for non-public material information that could enable insider trading."
    },
    {
      icon: FileWarning,
      title: "Document Tampering",
      desc: "Identifies signs of altered or manipulated documents that compromise integrity."
    },
    {
      icon: AlertTriangle,
      title: "Sexual Harassment",
      desc: "Flags inappropriate or harassing language to help maintain a safe workplace."
    },
    {
      icon: Radio,
      title: "Covert Communication",
      desc: "Catches attempts to move conversations to unmonitored or unauthorized channels."
    },
    {
      icon: Scale,
      title: "Fair Lending",
      desc: "Flags discriminatory language in lending communications to ensure compliance with ECOA."
    },
    {
      icon: Users,
      title: "Workplace Discrimination",
      desc: "Surfaces biased or unlawful remarks tied to protected classes in workplace communication."
    },
    {
      icon: ShieldAlert,
      title: "Restricted List",
      desc: "Prevents mentions of banned securities, entities, or individuals in communications."
    },
    {
      icon: Siren,
      title: "Threats / Intimidation",
      desc: "Detects threatening or coercive statements before they escalate into legal risk."
    },
    {
      icon: Plus,
      title: "+ many more",
      desc: "Nearly 50 domain-trained classifiers across compliance, conduct, and litigation risk."
    }
  ];

  return (
    <section id="classifiers" className="py-24 bg-accent/10 border-b border-border/40">
      <div className="container mx-auto px-0 md:px-6">
        <div className="mb-16 max-w-3xl mx-auto text-center px-6 md:px-0">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">
            ~50 Proprietary Classifiers
          </h2>
          <p className="text-lg text-muted-foreground">
            Purpose-built and continuously trained to catch nuance, slang, and covert language that keyword blockers and general-purpose tools miss entirely.
          </p>
        </div>

        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((c, i) => {
            const Icon = c.icon;
            return (
              <li
                key={i}
                className="border border-border/40 bg-background/40 hover:border-primary/40 transition-colors p-5 flex flex-col gap-3"
              >
                <Icon className="w-6 h-6 text-primary shrink-0" />
                <span className="text-base font-semibold text-white">{c.title}</span>
                <span className="text-sm text-white/70 leading-relaxed">{c.desc}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
